module.exports = __webpack_public_path__ + "static/media/tsb8ru.9bf42adb.pdf";